import React, { useEffect, useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import ControlledTextField from 'transfix-form/components/ControlledTextInput'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles } from 'transfix-ui/core/styles'
import { theme } from 'transfix-ui/theme'
import { TLastCreatedShipmentsFormSchema } from './LastCreatedShipmentsFormSchema'
import { useLastCreatedShipmentsForm } from './useLastCreatedShipmentsForm'

const getErrorMessage = <T extends FieldErrors<TLastCreatedShipmentsFormSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

export interface ILastCreatedShipmentsFormProps {
  /**
   * @default {}
   */
  defaultValues?: Partial<TLastCreatedShipmentsFormSchema>
  onSubmit: (options: TLastCreatedShipmentsFormSchema) => void
}

const useLastCreatedShipmentsFormStyles = makeStyles({
  btn: {
    marginTop: theme.spacing(2),
  },
})

export const LastCreatedShipmentsForm = ({
  defaultValues = {},
  onSubmit,
}: ILastCreatedShipmentsFormProps) => {
  const { control, errors, handleSubmit, watch } = useLastCreatedShipmentsForm({
    defaultValues,
  })

  const { numberOfShipments } = watch(['numberOfShipments'])

  const [isSubmitClicked, setIsSubmitClicked] = useState<Boolean>()

  const classes = useLastCreatedShipmentsFormStyles()

  const submitHandler = handleSubmit((data: TLastCreatedShipmentsFormSchema) => {
    setIsSubmitClicked(true)
    onSubmit(data)
  })

  /*
  Whenever there is change in number of shipments field, change the state of submit click to false
  */
  useEffect(() => {
    setIsSubmitClicked(false)
  }, [numberOfShipments])

  return (
    <form onSubmit={submitHandler} data-test='LastCreatedShipmentsForm'>
      <ControlledTextField
        name='numberOfShipments'
        control={control}
        TextInputProps={{
          type: 'number',
          validationMessage: getErrorMessage(errors, 'numberOfShipments'),
          error: !!getErrorMessage(errors, 'numberOfShipments'),
          dataTest: 'input-number-of-shipments',
        }}
      />
      <Button
        className={classes.btn}
        type='submit'
        color='primary'
        size='large'
        data-test='submit-button'>
        {isSubmitClicked ? 'Refresh' : 'Submit'}
      </Button>
    </form>
  )
}
